import React from "react";
import {FormHelperText} from "@material-ui/core";

const FieldErrorMessage = ({message = ''}) => {
    return (
        message.length > 0 && (
            <FormHelperText error variant={"outlined"} style={{margin: '0 0 0 2px'}}>
                {message}
            </FormHelperText>
        )

    )
};
export default FieldErrorMessage